module.exports = __webpack_public_path__ + "static/img/icon-img3.57d16f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/view/images/icon-img3.png
// module id = 6Mlk
// module chunks = 1